import { render } from "./financialVIP.vue?vue&type=template&id=10c10007&scoped=true"
import script from "./financialVIP.vue?vue&type=script&lang=js"
export * from "./financialVIP.vue?vue&type=script&lang=js"

import "./financialVIP.vue?vue&type=style&index=0&id=10c10007&scoped=true&lang=stylus"
import "./financialVIP.vue?vue&type=style&index=1&id=10c10007&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c10007"]])

export default __exports__